<template>
  <div>
    <div
      v-if="$store.state.user.isRegisterActive"
      class="popup-wrap register-wrap"
      :class="{ active: $store.state.user.isRegisterActive }"
    >
      <div class="popup-box fullScreen-md">
        <a class="popup-close" @click="deactivatePopup"><i class="fa-solid fa-xmark" /></a>
        <div class="form-popup popup-padding m-loginRegister-frame">
          <form class="row-frame dep-form-frame reg-popupBox">
            <h4 class="register-title font-w-b text-align-L">
              <span class="highlight-dark-red">{{ $t("Bao.create_account") }}</span>
              {{ $t("Bao.create") }}
            </h4>

            <div class="reg-form-group">
              <div class="reg-form-area">
                <div class="colu colu-auto">
                  <label class="colu-sm-12 colu-md-4 colu-12 colu-form-label title-label" for="username">
                    {{ $t("Bao.username") }}
                  </label>
                  <div class="colu-sm-12 colu-md-8 colu-12">
                    <input
                      v-model="postForm.username"
                      v-validate="'required'"
                      class="colu-12 for-input inpType"
                      :class="{ 'isInvalid': errors.has('username') || (usernameError && usernameError !== $t('Bao.username_available')) }"
                      type="text"
                      :placeholder="$t('Bao.member_username_limit')"
                      name="username"
                      :data-vv-as="$t('Bao.username')"
                      autocomplete="off"
                      @input="usercheck"
                    >
                  </div>
                  <div v-if="usernameError === $t('Bao.username_available')" class="account_good">
                    {{ usernameError }}
                  </div>
                  <div v-else-if="usernameError" class="input-feedback text-align-R">
                    {{ usernameError }}
                  </div>
                  <div v-else-if="errors.has('username')" class="input-feedback text-align-R">
                    {{ $t("Bao.user_name_error") }}
                  </div>
                </div>

                <div class="colu colu-auto">
                  <label class="colu-sm-12 colu-md-4 colu-12 colu-form-label title-label">
                    {{ $t("Bao.password") }}
                  </label>
                  <div class="colu-sm-12 colu-md-8 colu-12">
                    <input
                      ref="newPassword"
                      v-model="postForm.newPassword"
                      v-validate="'required'"
                      class="colu-12 for-input inpType"
                      :class="{ 'isInvalid': errors.has('check_pass') || pwdError }"
                      :placeholder=" $t('Bao.password_notice')"
                      type="password"
                      name="check_pass"
                      :data-vv-as="$t('Bao.newPassword')"
                      autocomplete="new-password"
                      @input="pwdCheck"
                    >
                  </div>
                  <div v-if="pwdError" class="input-feedback text-align-R">
                    {{ pwdError }}
                  </div>
                  <div v-else-if="errors.has('check_pass')" class="input-feedback text-align-R">
                    {{ $t("Bao.new_password_error") }}
                  </div>
                </div>

                <div class="colu colu-auto">
                  <label class="colu-sm-12 colu-md-4 colu-12 colu-form-label title-label" for="passwordz">
                    {{ $t("Bao.confirmPassword") }}
                  </label>
                  <div class="colu-sm-12 colu-md-8 colu-12">
                    <input
                      v-model="postForm.confirmPassword"
                      v-validate="'required|confirmed:newPassword'"
                      class="colu-12 for-input inpType"
                      :class="{ 'isInvalid': errors.has('check_confirm_pass') }"
                      type="password"
                      name="check_confirm_pass"
                      :placeholder="$t('Bao.confirm_pass')"
                      :data-vv-as="$t('Bao.confirmPassword')"
                      autocomplete="off"
                    >
                  </div>
                  <div v-if="errors.has('check_confirm_pass')" class="input-feedback text-align-R">
                    {{ $t("Bao.confirm_password_error") }}
                  </div>
                </div>

                <div v-if="email_need_verify" class="colu colu-auto">
                  <label class="colu-sm-12 colu-md-4 colu-12 colu-form-label title-label" for="">
                    {{ $t("Bao.e-mail") }}
                  </label>
                  <div class="colu-sm-12 colu-md-8 colu-12">
                    <input
                      v-model="postForm.email"
                      v-validate="'required'"
                      class="colu-12 for-input inpType"
                      :class="{ 'isInvalid': errors.has('check_email') }"
                      type="email"
                      name="check_email"
                      :placeholder="$t('Bao.e-mail')"
                      autocomplete="off"
                      @input="filterEmail"
                    >
                  </div>
                  <div v-if="errors.has('check_email')" class="input-feedback text-align-R">
                    <span>{{ $t("Bao.email_error") }}</span>
                  </div>
                </div>

                <div v-if="register_need_phone" class="colu colu-auto">
                  <label class="colu-sm-12 colu-md-4 colu-12 colu-form-label title-label" for="携帯番号">{{ $t("Bao.phone") }}</label>

                  <div class="colu-sm-12 colu-md-8 colu-12 country-select-frame">
                    <div class="row-frame ml-0">
                      <div class="colu-3 country-select-box" :class="{ active: isActive }" @click="toggleActive">
                        <div class="form-select-1 country-select">
                          <div class="form-select-value">
                            <div class="country-flag" />
                            <div class="country-code">
                              {{ selectedCode }}
                            </div>

                            <div class="country-list-box">
                              <ul class="country-list">
                                <li
                                  v-for="(code, key) in brand.supportPhoneCode"
                                  :key="key"
                                  @click.stop="selectCode(code)"
                                >
                                  <div class="country-flag" />
                                  <div class="country-code">
                                    {{ code }}
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <i class="fa-solid fa-angle-right" />
                      </div>
                      <div class="colu-9 number-box">
                        <input
                          v-model="postForm.phone"
                          v-validate="'required'"
                          class="colu-12 for-input inpType"
                          :class="{ 'isInvalid': phoneError && phoneError !== $t('Bao.phone_available') }"
                          type="text"
                          name="phone"
                          :data-vv-as="$t('Bao.phone')"
                          :required="true"
                          autocomplete="off"
                          @input="phonecheck"
                        >
                      </div>
                    </div>
                  </div>

                  <div v-if="phoneError === $t('Bao.phone_available')" class="account_good">
                    {{ phoneError }}
                  </div>
                  <div v-else-if="phoneError" class="input-feedback text-align-R">
                    {{ phoneError }}
                  </div>
                </div>
              </div>
            </div>

            <div class="form-agree">
              <div class="form-checkbox checkbox-wrapper-40">
                <label class="control">
                  <input v-model="agree" type="checkbox" @click="agree_error = false">
                  <span class="register-agree-text">{{ $t("Bao.i_read_and_agree") }}
                    <template v-if="themeConfig.showMemberTerms">
                      《
                      <span to="/page/privacy" @click="goMemberTerms()">{{ $t("Bao.member_terms") }}</span>
                      》
                    </template>
                  </span>
                </label>
              </div>
              <div v-show="agree_error">
                <div class="input-feedback">
                  {{ $t("Bao.have_to_agree_member_terms") }}
                </div>
              </div>
              <div class="form-button form-ft">
                <button
                  class="btn-primary goTo-fun-sec-authen"
                  type="button"
                  :disabled="isButtonDisabled"
                  @click.prevent="getVerificationPop"
                >
                  <span>{{ $t("Bao.sign_up_now") }}</span>
                  <i v-show="actionLoading" class="fa fa-spinner fa-pulse fa-fw" />
                </button>
              </div>
              <div class="form-text">
                {{ $t("Bao.account_check") }}
                <a @click="navigateToLogin">
                  {{ $t("Bao.login") }}
                </a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!--註冊成功-->
    <div v-if="isRegisterSuccess" class="popup-wrap text-center" :class="{ active: isRegisterSuccess }">
      <div class="popup-box">
        <div class="popup-success">
          <i><img :src="$getThemeImagePath('icon-register-success.png')" alt=""></i>
          <h3>{{ $t("Bao.congratulations") }}</h3>
          <h5>{{ $t("Bao.complete_register") }}</h5>
          <h5>{{ $t("Bao.complete_register_explain") }}</h5>
          <button class="button-style-5" @click="closeRegisterSuccess">
            <span>{{ $t("Bao.enter") }}</span>
          </button>
        </div>
        <a class="popup-close" @click="closeRegisterSuccess"><i class="fa-solid fa-xmark" /></a>
      </div>
    </div>

    <!-- 驗證彈窗 -->
    <div v-if="limitVerify && email_need_verify || register_need_phone" class="popup-wrap register-wrap fun-sec-authen" :class="{ active: limitVerify }">
      <div class="popup-box fullScreen-md">
        <a class="popup-close" href="javascript:;" @click="closeVerify"><i class="fa-solid fa-xmark" /></a>
        <div class="form-popup popup-padding">
          <form class="row-frame dep-form-frame reg-popupBox">
            <h4 class="register-title font-w-b text-align-L">
              {{ email_need_verify ? $t("Bao.verify_email") : register_need_phone ? $t("Bao.verify_phone") : '' }}
            </h4>

            <div class="reg-form-group">
              <div class="reg-form-area">
                <div class="colu colu-auto">
                  <label class="colu-12 colu-form-label title-label let-lessen">
                    <span>
                      {{ email_need_verify ? $t("Bao.verify_email_code") : register_need_phone ? $t("Bao.verify_phone_code") : '' }}
                    </span>
                  </label>
                  <div class="colu-12">
                    <input
                      v-if="email_need_verify"
                      v-model="postForm.emailValidateCode"
                      class="colu-12 for-input inpType"
                      :class="{ 'isInvalid': errors.has('emailValidateCode')}"
                      type="text"
                      name="emailValidateCode"
                      autocomplete="off"
                    >
                    <input
                      v-if="register_need_phone"
                      v-model="postForm.validateCode"
                      class="colu-12 for-input inpType"
                      :class="{ 'isInvalid': errors.has('phoneValidateCode')}"
                      type="text"
                      name="phoneValidateCode"
                      autocomplete="off"
                    >
                  </div>
                  <div v-if="errors.has('emailValidateCode') || errors.has('phoneValidateCode')" class="input-feedback text-align-R">
                    {{ $t("Bao.validate_code_error") }}
                  </div>
                </div>
                <div>
                  <div class="form-button form-ft">
                    <button
                      class="btn-primary"
                      :disabled="email_need_verify ? isHandleButtonDisabled : isPhoneButtonDisabled"
                      @click.prevent="executeRegistration"
                    >
                      <span>{{ $t("Bao.verify_register") }}</span>
                    </button>
                  </div>
                </div>

                <div class="colu colu-auto">
                  <i class="icon-alert mr-1"><img :src="$getThemeImagePath('icon-detail.png')" alt=""></i>
                  <b class="color-primary">{{ $t("Bao.email_notice_4") }}</b>
                  <span class="let-lessen">
                    {{ email_need_verify ? $t("Bao.email_notice_5") : register_need_phone ? $t("Bao.phone_notice_5") : '' }}
                  </span>
                </div>
                <div class="colu-auto">
                  <b class="color-primary">{{ $t("Bao.email_notice_1") }}</b>
                </div>
                <div class="colu-auto">
                  <p v-if="email_need_verify">
                    {{ $t("Bao.email_notice_2") }} {{ $t("Bao.email_notice_3") }}
                  </p>
                  <p v-if="register_need_phone">
                    {{ $t("Bao.phone_notice_3") }}
                  </p>
                </div>
              </div>
            </div>

            <div>
              <div class="authen-btn-wrap">
                <button class="btn-primary goTo-fun-sec-authen btn-mb-w-100" @click.prevent="changeEmail">
                  <span>
                    {{ email_need_verify ? $t("Bao.email_change") : register_need_phone ? $t("Bao.phone_change") : '' }}
                  </span>
                </button>
                <button
                  class="btn-primary goTo-fun-sec-authen btn-mb-w-100"
                  :disabled="timerCount"
                  @click.prevent="getVerificationPop"
                >
                  <i v-show="timerCount" class="fa fa-spinner fa-pulse fa-fw" />
                  <span>{{ timerCount ? '' + limitSecond + 's' : $t('Bao.get_verification_code') }}</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPhoneCode, getEmailCode, register, usernameCheck, phoneCheck } from '@/api/user'
import { sendRegisterEvent } from '@/utils/pixel'
import { showNotice } from '@/utils/tool'
import { validatePassword } from '@/utils/validate'
import { login as localLogin } from '@/utils/user'
import { mapGetters } from 'vuex'
import themeMixin from '@/mixins/themeMixin'

export default {
  mixins: [themeMixin],
  data() {
    const postForm = {
      username: null,
      newPassword: null,
      email: null,
      confirmPassword: null,
      emailValidateCode: null,
      validateCode: null,
      phone: null,
      promotion_code: null,
      track_code: null,
      group: null
    }
    return {
      actionLoading: false,
      postForm,
      limitSecond: 180,
      timerCount: true,
      limitVerify: false,
      isCodeReadOnly: false,
      agree: false,
      agree_error: false,
      isRegisterSuccess: false,
      phoneValid: true,
      usernameError: '',
      pwdError: '',
      phoneError: '',
      isNameValid: true,
      isPwdValid: true,
      isPhoneValid: false,
      isActive: false,
      selectedCode: ''
    }
  },
  computed: {
    ...mapGetters(['brand', 'permissionInfo']),
    register_need_phone() {
      return this.permissionInfo.register_need_phone
    },
    email_need_verify() {
      return this.permissionInfo.email_need_verify
    },
    isButtonDisabled() {
      const hasErrors = this.errors.any()
      /* eslint-disable no-unused-vars */
      let formToCheck
      if (this.email_need_verify === 1) {
        const { emailValidateCode, validateCode, promotion_code, track_code, group, phone, ...rest } = this.postForm
        formToCheck = rest
      } else {
        const { emailValidateCode, validateCode, promotion_code, track_code, group, email, ...rest } = this.postForm
        formToCheck = rest
      }
      const hasEmptyFields = Object.values(formToCheck).some(value => value === null || value === '')
      return hasErrors ||
            !this.agree ||
            !this.isNameValid ||
            !this.isPwdValid ||
            (this.email_need_verify !== 1 && !this.isPhoneValid) || // 僅當不是1時才檢查 isPhoneValid
            hasEmptyFields
    },
    isHandleButtonDisabled() {
      return this.postForm.emailValidateCode === null ||
             this.postForm.emailValidateCode && this.postForm.emailValidateCode.trim() === ''
    },
    isPhoneButtonDisabled() {
      return this.postForm.validateCode === null ||
             this.postForm.validateCode && this.postForm.validateCode.trim() === ''
    }
  },
  watch: {
    'postForm.emailValidateCode': function(newValue) {
      if (this.email_need_verify) {
        if (!newValue || newValue.trim() === '') {
          this.$validator.errors.add({
            field: 'emailValidateCode',
            msg: this.$t('Bao.validate_code_error')
          })
        } else {
          this.$validator.errors.remove('emailValidateCode')
        }
      }
    },
    'postForm.validateCode': function(newValue) {
      if (this.register_need_phone) {
        if (!newValue || newValue.trim() === '') {
          this.$validator.errors.add({
            field: 'phoneValidateCode',
            msg: this.$t('Bao.validate_code_error')
          })
        } else {
          this.$validator.errors.remove('phoneValidateCode')
        }
      }
    },
    'brand.supportPhoneCode': {
      handler(newVal) {
        if (newVal && newVal.length > 0 && !this.selectedCode) {
          this.selectedCode = newVal[0]
        }
      },
      immediate: true
    }
  },
  created() {
    this.setCode(this.$store.getters.inviteCode, 'inviteCode', 'promotion_code')
    this.setCode(this.$store.getters.shareCode, 'shareCode', 'promotion_code')
    // setCode(this.$store.getters.couponCode, 'couponCode', 'coupon_code')

    if (this.$store.getters.group !== null) {
      this.postForm.group = this.$store.getters.group
    }

    let url = (window.location.href || document.location.href).replace('&amp;', '&')
    url = url.replace('&amp%3B', '&')
    const trackCode = new URL(url).searchParams.get('trackCode')
    if (trackCode) {
      this.$store.commit('SET_TRACK_CODE', trackCode)
      this.postForm.track_code = trackCode
    }

    this.debounceCheckUsername = this.debounce(this.usernameApiCall, 700)
    if (this.register_need_phone) {
      this.debounceCheckPhone = this.debounce(this.phoneApiCall, 500)
    }
  },
  methods: {
    usernameApiCall() {
      if (this.postForm.username && this.postForm.username.trim() !== '') {
        usernameCheck({ username: this.postForm.username }).then(res => {
          if (res.status === 200) {
            // 检查是否全数字
            const isAllDigits = /^\d+$/.test(this.postForm.username)
            // 检查是否全英文（仅限字母）
            const isAllLetters = /^[A-Za-z]+$/.test(this.postForm.username)
            // 检查是否包含标点符号
            const hasPunctuation = /[^\w\s]/.test(this.postForm.username)
            // 含大寫英文
            const hasUpperCase = /[A-Z]/.test(this.postForm.username)

            if (isAllDigits || isAllLetters || hasPunctuation || hasUpperCase) {
              this.isNameValid = false
              this.usernameError = this.$t('Bao.username_format_error')
            } else {
              this.usernameError = this.$t('Bao.username_available')
              this.isNameValid = true
            }
          } else if (res.status === 201) {
            if (this.postForm.username.length < 8) {
              this.usernameError = this.$t('Bao.username_format_error')
            } else {
              this.usernameError = this.$t('Bao.username_duplicate')
            }
            this.isNameValid = false
          }
        }).catch(err => {
          console.log(err)
          this.isNameValid = false
        })
      }
    },
    pwdCheck() {
      const { valid, error } = validatePassword(this.postForm.newPassword, this.$t.bind(this))
      this.isPwdValid = valid
      this.pwdError = error
    },
    phoneApiCall() {
      if (this.postForm.phone && this.postForm.phone.trim() !== '') {
        phoneCheck({ phone: this.selectedCode + this.postForm.phone }).then(res => {
          this.phoneError = this.$t('Bao.phone_available')
          this.isPhoneValid = true
        }).catch(err => {
          console.log(err)
          this.phoneError = this.$t('Bao.phone_error')
          this.isPhoneValid = false
        })
      }
    },
    phonecheck() {
      if (!this.postForm.phone) {
        this.phoneError = this.$t('Bao.phone_error')
        this.isPhoneValid = false
      } else {
        this.debounceCheckPhone()
      }
    },
    usercheck() {
      if (!this.postForm.username) {
        this.usernameError = this.$t('Bao.user_name_error')
        this.isNameValid = false
      }
      if (this.postForm.username) {
        this.debounceCheckUsername()
      }
    },
    debounce: function(func, wait) {
      let timeout
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout)
          func(...args)
        }
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
      }
    },
    goMemberTerms() {
      this.agree_error = false
      this.$store.commit('SET_REGISTER_OPEN', false)
      this.$router.push('/page/terms')
    },
    countDown() {
      const timer = setInterval(() => {
        if (this.limitSecond > 0) {
          this.limitSecond--
        } else {
          this.timerCount = false
          this.limitSecond = 180
          clearInterval(timer)
        }
      }, 1000)
    },
    closeVerify() {
      this.$store.commit('SET_REGISTER_OPEN', true)
      this.limitVerify = false
      this.agree_error = false
      this.resetPostForm()
    },
    closeRegisterSuccess() {
      this.isRegisterSuccess = false
      if (this.$store.state.user.newMember.member_info.member_type !== 3) {
        this.$store.commit('SET_REGISTER_SUCCESS', true)
      }

      localStorage.removeItem('inviteCode')
      localStorage.removeItem('shareCode')
      localStorage.removeItem('couponCode')
      this.$store.commit('SET_INVITE_CODE', null)
      this.$store.commit('SET_SHARE_CODE', null)
      this.$store.commit('SET_COUPON_CODE', null)
      this.$store.commit('SET_BTAG_CODE', null)

      localLogin(this.$store.state.user.newMember, null)
    },
    deactivatePopup() {
      this.$store.commit('SET_REGISTER_OPEN', false)
      this.errors.clear()
      this.agree_error = false
    },
    navigateToLogin() {
      this.$store.commit('SET_REGISTER_OPEN', false)
      this.$store.commit('SET_LOGIN_OPEN', true)
      this.errors.clear()
      this.agree_error = false
    },
    openEmailVerify() {
      const emailToUse = this.postForm.email
      getEmailCode({ email: emailToUse }).then(response => {
        showNotice(response.data.msg)
        this.$store.commit('SET_REGISTER_OPEN', false)
        this.timerCount = true
        this.limitVerify = true
        this.countDown()
      }).catch((error) => {
        this.limitVerify = false
        showNotice(error.response.data.msg)
      })
    },
    openPhoneVerify() {
      getPhoneCode({ phone: this.selectedCode + this.postForm.phone }).then(response => {
        showNotice(response.data.msg)
        this.$store.commit('SET_REGISTER_OPEN', false)

        this.timerCount = true
        this.limitVerify = true
        this.countDown()
      }).catch((error) => {
        this.limitVerify = false
        showNotice(error.response.data.msg)
      })
    },
    changeEmail() {
      this.limitVerify = false
      this.postForm.phone = ''
      this.isPhoneValid = false
      this.phoneError = ''
      this.$store.commit('SET_REGISTER_OPEN', true)
    },
    getVerificationPop() {
      if (this.email_need_verify) {
        this.openEmailVerify()
        return
      } else {
        this.openPhoneVerify()
      }
    },
    hasValues(form) {
      return Object.values(form).every(value => value !== null && value !== '')
    },
    setCode(storeValue, localStorageKey, formField) {
      if (storeValue) {
        this.postForm[formField] = storeValue
        this.isCodeReadOnly = true
      } else {
        const localValue = localStorage.getItem(localStorageKey)
        if (localValue) {
          this.postForm[formField] = localValue
          this.isCodeReadOnly = true
        }
      }
    },
    executeRegistration() {
      this.actionLoading = true
      this.setCode(this.$store.getters.btag, 'btag', 'btag')
      this.postForm.password = this.postForm.newPassword

      if (this.email_need_verify) {
        this.postForm.phone = null
      } else {
        this.postForm.phone = this.selectedCode + this.postForm.phone
      }

      register(this.postForm).then(response => {
        if (this.isTheme('theme_gold') && process.env.VUE_APP_ENV === 'production') {
          sendRegisterEvent()
        }
        const tokenData = response.data.data.token
        const expiredTime = new Date().getTime() + (tokenData.expired_interval * 1000)
        localStorage.setItem('expired_time', expiredTime)
        localStorage.setItem('token', tokenData.token)
        localStorage.removeItem('inviteCode')
        localStorage.removeItem('shareCode')
        localStorage.removeItem('couponCode')
        this.$store.commit('SET_INVITE_CODE', null)
        this.$store.commit('SET_SHARE_CODE', null)
        this.$store.commit('SET_COUPON_CODE', null)
        this.$store.commit('SET_BTAG_CODE', null)

        if (window.gtag) {
          window.gtag('event', 'success_click', {
            'event_category': 'button',
            'event_label': 'success_button',
            'value': 1
          })
        }

        this.isRegisterSuccess = false
        this.$store.commit('SET_NEW_MEMBER', response.data.data)
        this.resetPostForm()
        this.limitVerify = false
        const loginUI = (this.isTheme('theme_purple') || this.isTheme('theme_tiger')) ? '' : 'personal/data/modal'
        localLogin(response.data.data, loginUI)
      }).catch((error) => {
        showNotice(error.response.data.msg)
      }).finally((e) => {
        this.actionLoading = false
      })
    },
    resetPostForm() {
      this.$validator.errors.items = []
      this.postForm = {
        username: null,
        newPassword: null,
        confirmPassword: null,
        email: null,
        emailValidateCode: null,
        validateCode: null,
        phone: null,
        promotion_code: null,
        track_code: null,
        group: null
      }

      this.usernameError = ''
      this.phoneError = ''
      this.pwdError = ''
    },
    filterEmail(e) {
      this.postForm.email = e.target.value.replace(/\+/g, '')
    },
    toggleActive() {
      this.isActive = !this.isActive
    },
    selectCode(code) {
      this.isActive = false
      this.selectedCode = code
    }
  }
}
</script>

